<template>
    <section id="aboutus">
    <v-layout
            column
            wrap
            class="my-12"
            align-center
    >
        <v-flex xs12 sm4 class="my-4">
            <div class="text-center">
                <h2 class="headline">Über uns</h2>
                <span class="subheading">
                Neue Leitung seit Juli 2019
              </span>
            </div>
        </v-flex>
        <v-flex xs12>
            <v-container grid-list-xl>
                <v-layout row wrap align-center>
                    <v-flex xs12 md4>
                        <v-card flat class="transparent" height="15vh" min-height="240px">
                            <v-card-text class="text-center">
                                <v-icon x-large class="blue--text text--lighten-2">mdi-forum</v-icon>
                            </v-card-text>
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Erreichbarkeit</div>
                            </v-card-title>
                            <v-card-text>
                                Da es noch keine Smartphones mit 10.000mah Akku gibt,
                                können wir nicht 24/7 online sein. Falls man aber mal
                                jemanden braucht der mit einem boostet, haben wir eine
                                <b>WhatsApp Gruppe</b> und
                                einen <a href="https://discord.gg/WbD72HU" style="text-decoration: none; color: #737373"><b>Discord</b></a>.
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-card flat class="transparent" height="15vh" min-height="240px">
                            <v-card-text class="text-center">
                                <v-icon x-large class="blue--text text--lighten-2">mdi-account-group</v-icon>
                            </v-card-text>
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline">Spendenaktivität</div>
                            </v-card-title>
                            <v-card-text>
                                Jede Season über 120.000 Spenden. Wenn ihr am boosten seit,
                                oder Truppen für den Clankrieg oder die Clankriegsliga benötigt könnt
                                ihr einfach in der WhatsApp Gruppe oder unserem <a href="https://discord.gg/WbD72HU" style="text-decoration: none; color: #737373"><b>Discord</b></a> bescheid geben.

                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-card flat class="transparent" height="15vh" min-height="240px">
                            <v-card-text class="text-center">
                                <v-icon x-large class="blue--text text--lighten-2">mdi-graph</v-icon>
                            </v-card-text>
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Strukturierung</div>
                            </v-card-title>
                            <v-card-text>
                                Im <b>Clankrieg</b> wird die Angriffstrategie über die "Notizen"
                                und die "Ziel beanspruchen" Funktion bekannt gegeben. <br/>
                                Die <b>Clankriegsliga</b>  wird zusätzlich über die WhatsApp Gruppe geplant.<br/>
                            </v-card-text>
                            <v-card-actions><div class="flex-grow-1"></div><v-btn @click="$vuetify.goTo('#rules',options)" text>Regeln</v-btn></v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
    </section>
</template>
<script>
    export default {
        name: 'AboutUs',
        data: () => ({
            TotalSpende: 104.876,
            TotalGefordert: 125.176
        }),
        computed: {
            options() {
                return {
                    offset: 55
                }
            },
        },
    };
</script>
